import { useContext, useEffect, useState } from 'react';
import { Select, Typography } from '@mui/material';
import { strapiRequest } from '../../functions/axiosRequest';
import { LanguageContext } from '../../context/LanguageContext';

export default function TypeSelect({ selectedType, setSelectedType, textData }){

	const [types, setTypes]=useState();
	const locale = useContext(LanguageContext);

	//Fetch product categories after translation data becomes available / when language changes
	useEffect(()=>{
		if(textData){
			strapiRequest({
				method: 'get',
				endpoint: 'resource-types',
				params: { locale: locale.lang.code }
			}).then((response)=>{
				const all=[{documentId:'all', name:textData.repository_type_select_all}, ...response.data];
				setTypes(all);
				setSelectedType(all[0]);
			}).catch((error)=>{
				console.log(error);
			});
		}
	},[textData, locale.lang.code]);

	return(
		<>
			<Typography
				sx={{
					fontSize:'0.8rem',
					color:'grey'
				}}
			>
				{textData?.repository_type_select}
			</Typography>
			<Select
				native
				fullWidth
				value={selectedType?.documentId}
				onChange={(event)=>{
				const match=types.find(type=>type.documentId===event.target.value);
					if(match){
						//console.log(match)
						setSelectedType(match);
					}
				}}
			>
				{types?.map((type, i)=>{
					return(
						<option
							value={type.documentId}
							key={i}
						>
							{type.name}
						</option>
					);
				})}
			</Select>
		</>
	);
};
